import React, { Component } from "react";
import { Container, Row, Col, CardBody } from "shards-react";
import { FloatingButton, Item as FItem } from "react-floating-button";
import ReactHoverObserver from 'react-hover-observer';
import IconDisplay from "../components/common/IconDisplay";
import { FiYoutube } from "react-icons/fi";
import { MdAssignment } from "react-icons/md";
import { getVideo, upload, uploadVideo,deleteVideo,getChunks,chunkUpload,getChunkCount,getChunkSize } from "../services/api";

import Modal from "react-modal";
import { Menu, Item, contextMenu } from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
import axios from "axios";
import Navigate from "./Navigate";
import { Store } from "../flux";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  FormInput,
  Button
} from "shards-react";
import ModalVideo from "react-modal-video";
import Load from "../Load";
import { Video } from 'react-video-stream'


// const config = {
//   onUploadProgress: progressEvent => {
//     let progress = (progressEvent.loaded / progressEvent.total) * 100;
//    console.log(progress);
//   }
// }
const options = {
  requestHeader: 'ContentType',
  requestToken: 'video/mp4'
}

class Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress:0,
      fileSize:0,
      currentUser: Store.getCurrentUser(),
      isOpen: false,
      url: null,
      showModal: false,
      loading:true,
      editModal: { open: false, elements: [] },
      buttonTheme: "primary",
      buttonText: "Publish",
      uploadUrl: "",
      resource: {
        src: "",
        thumbnail: "https://www.lesson21.com/app/upload/uploads/216968-pdf.jpg",
        thumbnailWidth: 320,
        thumbnailHeight: 320,
        tags: [
          { value: "Ocean", title: "Ocean" },
          { value: "People", title: "People" }
        ],
        caption: ""
      },
      videos: [],
      uploadUrl: "",
      fileName: ""
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }
  config = {
    onUploadProgress: progressEvent => {
      this.progressSum+=progressEvent.loaded;
      let progress = (this.progressSum / this.state.fileSize) * 100;
      if(parseInt(progress) >=100){
        this.progressSum = 0;
        progress = 100;
      }
      this.setState({...this.state,buttonText:`Uploading ${parseInt(progress)}%`})
    }
  }
  progressSum = 0;
  showMenu(e, book) {
    if (this.state.currentUser.Type !== "STUDENT") {
      contextMenu.show({
        id: `item`,
        event: e,
        props: {
          key: book
        }
      });
    }
  }
  setOpen(val, id) {
    this.setState({
      isOpen: val,
      url: id != null ? this.state.videos[id].src : null
    });
    
  }

  handleItemClick = ({ event, props }) => {
    this.setState({
      ...this.state,
      editModal: { open: true, elements: [props] }
    });
  };
  handleClose = () => {
    this.setState({ ...this.state, editModal: { open: false, elements: [] } });
  };
  handleOpenModal() {
    this.setState({ ...this.state, showModal: true });
  }

  handleCloseModal() {
    this.setState({ ...this.state, showModal: false });
  }
  componentDidMount() {
    getVideo(this.props.match.params.id, this.state.currentUser)
      .then(data => {
        this.setState({ ...this.state, videos: data,loading:false });
      }).catch(err => {this.setState({...this.state,videos:[],loading:false})});
  }
  handleDelete(event) {
    this.setState({...this.state,loading:true});
    let obj = event.props.key;
    console.log(obj);
    deleteVideo(obj.id,this.state.currentUser,obj.src)
      .then(() => {
        getVideo(this.props.match.params.id, this.state.currentUser).then(
          data => {
            this.setState({ ...this.state, videos: data, loading:false });
          }
        ).catch(()=>{this.setState({...this.state,videos:[],loading:false})});
      })
      .catch(() => {this.setState({...this.state,loading:false});});
  }
  render() {
    var spanStyles = [];
    var copyStyles = [];
    this.state.videos.map((book, idx) => {
      spanStyles.push({ backgroundColor: "#fef3d6", color: "#feb628" });
    });
    copyStyles = [...spanStyles]
    if (this.state.hover) {
      spanStyles = [...copyStyles];
      spanStyles[this.state.hoverId] = {
        backgroundColor: "#feb628",
        color: "white"
      };
    } else {   
      spanStyles[this.state.hoverId] = {
        backgroundColor: "#fef3d6",
        color: "#00e952"
      };
    }
    return this.state.loading ? (
      <Container style={{height: window.innerHeight-80}} fluid className="main-content-container px-4">
        <Load />
      </Container>
    ) :(
      <Container style={{height: window.innerHeight-80}} fluid className="main-content-container px-4">
        {this.state.currentUser.Type !== "STUDENT" ? (
          <FloatingButton>
            <FItem
              backgroundColor={`#FFFFFF`}
              imgSrc={`data:image/png;base64,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`}
              onClick={this.handleOpenModal}
            />
             <FItem
              backgroundColor={`#FFFFFF`}
              imgSrc={`data:image/png;base64,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`}
              onClick={()=>{this.props.history.push(`/grades/${this.props.match.params.id}`)}}
            />
             <FItem
              backgroundColor={`#FFFFFF`}
              imgSrc={`data:image/png;base64,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`}
              onClick={()=>{this.props.history.push(`/attendance/${this.props.match.params.id}`)}}
            />
              <FItem
              backgroundColor={`#FFFFFF`}
              imgSrc={`data:image/png;base64,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`}
              onClick={()=>{this.props.history.push(`/attendancelist/${this.props.match.params.id}`)}}
            />
          </FloatingButton>
        ) : (
          ""
        )}
        {/* <div>
        <button onClick={this.handleOpenModal}>Trigger Modal</button> */}
        <Menu id={`library`}>
          <Item onClick={this.handleOpenModal}>Upload</Item>
        </Menu>
        <Menu id={`item`}>
          <Item onClick={this.handleDelete}>Delete</Item>
        </Menu>
        <Modal
          isOpen={this.state.showModal}
          contentLabel="onRequestClose Example"
          onRequestClose={this.handleCloseModal}
          shouldCloseOnOverlayClick={true}
          className="library_modal"
          overlayClassName="library_overlay"
          ariaHideApp={false}
        >
          <Card small>
            {/* Files & Dropdowns */}
            <CardHeader className="border-bottom">
              <h6 className="m-0">Upload a Video</h6>
            </CardHeader>

            <ListGroup flush>
              <ListGroupItem className="px-3">
                <strong className="text-muted d-block mb-2">Name</strong>
                <div className="custom-file mb-3">
                  <FormInput
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        fileName: e.target.value
                      });
                    }}
                  />
                </div>
                <strong className="text-muted d-block mb-2">
                  Upload Video
                </strong>
                <div className="custom-file mb-3">
                  <input
                    type="file"
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        buttonTheme: "warning",
                        fileSize:e.target.files[0].size,
                        buttonText: "Uploading 0%"
                      });
                      
                      
                     
                  chunkUpload(e,this.config,this.state.currentUser)
                        .then(data => {
                          this.setState({
                            ...this.state,
                            uploadUrl: data,
                            buttonTheme: "success",
                            buttonText: "Publish"
                          });
                        })
                        .catch((err) => {
                          if(err=="You have exceeded your storage quota. Please Upgrade."){
                            alert(err);
                            this.setState({ ...this.state, showModal: false });
                          }
                        });
                    }}
                    className="custom-file-input"
                    id="customFile2"
                  />
                  <label className="custom-file-label" htmlFor="customFile2">
                    Choose file...
                  </label>
                </div>
                <div className="custom-file mb-3">
                  <Button
                    disabled={this.state.buttonText !== "Publish"}
                    theme={this.state.buttonTheme}
                    onClick={() => {
                      uploadVideo(
                        this.state.uploadUrl,
                        this.state.fileName,
                        this.props.match.params.id,
                        this.state.currentUser
                      )
                        .then(data => {
                          getVideo(
                            this.props.match.params.id,
                            this.state.currentUser
                          )
                            .then(data => {
                              this.setState({
                                ...this.state,
                                showModal: false,
                                videos: data
                              });
                            })
                            .catch(err => console.log(err));
                        })
                        .catch(err => console.log(err));
                    }}
                  >
                    {this.state.buttonText}
                  </Button>
                </div>
              </ListGroupItem>
            </ListGroup>
          </Card>
        </Modal>
        {/* </div> */}
        {/* Page Header */}
        <Navigate history={this.props.history} match={this.props.match} />

        <Row>
            {this.state.videos.map((book, index) => (
               <Col
               lg="4"
               key={index}
               onContextMenu={e => {
                this.showMenu(e, book);
               }}
               onClick={() => {
                this.setOpen(true, index);
               }}
             >
                <ReactHoverObserver>
         {({ isHovering }) => (
               <Card
                 small
                 className="card-post mb-4"
                 style={{ height: "80px"}}
               >
                 <CardBody>
                
                   <span
                     className="lessonIcon"
                     style={!isHovering ? {
                       float: "left",
                       marginRight: "10px",
                       paddingLeft: "8px",
                       paddingRight: "8px",
                       paddingTop: "5px",
                       paddingBottom: "5px",
                       borderRadius: "0.5rem",
                       ...spanStyles[index]
                     }:{ float: "left",
                     marginRight: "10px",
                     paddingLeft: "8px",
                     paddingRight: "8px",
                     paddingTop: "5px",
                     paddingBottom: "5px",
                     borderRadius: "0.5rem",
                     backgroundColor: "#feb628",
                     color: "white"}}
                   >
                     <MdAssignment />
                   </span>
        
                   <h6
                     style={{
                       paddingLeft: "7px",
                       paddingRight: "7px",
                       paddingTop: "4px",
                       paddingBottom: "4px"
                     }}
                     className="card-title"
                   >
                     {book.caption}
                   </h6>
                 </CardBody>
               </Card>
                )}
                </ReactHoverObserver>
             </Col>
              // <IconDisplay
              //   icon={<FiYoutube></FiYoutube>}
              //   context={e => {
              //     this.showMenu(e, book);
              //   }}
              //   key={index}
              //   bookClick={() => {
              //     this.setOpen(true, index);
              //   }}
              //   iconSize="4em"
              //   title={book.caption}
              // />
            ))}

            {/* <Gallery onClickThumbnail={(index )=>{this.setOpen(true,  index ) }} images={this.state.videos}/> */}
            <React.Fragment>
              <ModalVideo
                channel="custom"
                autoplay
                isOpen={this.state.isOpen}
                url={this.state.url}
                onClose={() => this.setOpen(false, null)}
              />
               {/* <Video
        className='video-class'
        controls={true}
        autoPlay={true}
        remoteUrl={this.state.url}
      /> */}
            </React.Fragment>
      
        </Row>
      </Container>
    );
  }
}

export default Videos;
